import { useTranslation } from 'react-i18next';
import Button from '../../../components/primitives/button';
import type { ProfileCardContract } from './profileCard.contract';

type ProfileCardProps = {
  contract: ProfileCardContract;
};

export function ProfileCard({ contract }: ProfileCardProps) {
  const { t } = useTranslation();
  const { surface, identity, progress } = contract;
  const showOnboarding = surface === 'dashboard' || surface === 'pre-edit';
  const showProgress = surface !== 'read' && progress != null;
  const hint = showOnboarding ? progress?.hint : null;
  const cta = showOnboarding ? progress?.cta : null;

  return (
    <div
      className={[
        'student-wrapper',
        'profile-wrapper',
        'profile-wrapper--onboarding',
        identity.avatarEdit ? 'profile-wrapper--avatar-edit' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="profile-wrapper__picture">{identity.picture}</div>
      <div className="profile-wrapper__info">
        <p className="profile-wrapper__info-FIO">{identity.displayName}</p>
        {identity.timezoneLabel ? (
          <p className="profile-wrapper__info-date">{identity.timezoneLabel}</p>
        ) : null}
        <p className="profile-wrapper__info-title">{identity.title}</p>
        {identity.sku ? (
          <p className="profile-wrapper__info-sku">
            <span className="profile-wrapper__info-sku-label">
              {identity.skuLabel}
            </span>
            <span className="profile-wrapper__info-sku-value">{identity.sku}</span>
          </p>
        ) : null}
        {hint ? <p className="profile-wrapper__info-hint">{hint}</p> : null}
        {showProgress && progress ? (
          <div
            className="profile-wrapper__progress"
            role="progressbar"
            aria-valuenow={progress.percent}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={t('dashboard.profileCard.progress_label', {
              percent: progress.percent,
            })}
          >
            <div className="profile-wrapper__progress-track">
              <div
                className="profile-wrapper__progress-fill"
                style={{ width: `${progress.percent}%` }}
              />
            </div>
            <span className="profile-wrapper__progress-value">
              {t('dashboard.profileCard.progress_label', {
                percent: progress.percent,
              })}
            </span>
          </div>
        ) : null}
        {cta ? (
          <div className="profile-wrapper__cta">
            <Button
              onClick={cta.onClick}
              className={cta.primary ? 'black-btn' : 'border-btn'}
              title={cta.label}
              titleClassName={
                cta.primary ? 'swlc-16-400-24-white' : 'swlc-16-400-24-black'
              }
              buttonHeight="36px"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
